import Immutable from 'immutable';

export const State = Immutable.fromJS({

});
